import type { IAction } from '../../action/IAction';
import type { WorkOrder } from '../WorkOrder';
import { ActionArgs } from '../../action/ActionArgs';
import { Field, ID, InputType } from 'type-graphql'

@InputType()
export class ComputeWorkOrderTaskProgressArgs extends ActionArgs {
  @Field(() => ID)
  workOrderId: string
}

export interface IComputeWorkOrderTaskProgress extends IAction<WorkOrder, ComputeWorkOrderTaskProgressArgs> {}

